<template>
  <section class="cart-section" :style="{ backgroundImage: `url(${profileConfig.bg})` }">
    <Header />
    <div class="cart-title">
      <router-link style="display: flex" :to="{ name: cartProviderActivity.name, params: { stream: cartProviderActivity.params.stream ? cartProviderActivity.params.stream : '' } }"><i class="fas fa-star"></i></router-link>
      <label>Favoritos</label>
    </div>
    <div class="cart-container" style="max-width: 780px" v-if="cartItems.length == 0">
      <span class="cart-preview-container" style="font-size: 1.6rem">
        Você ainda não adicionou nenhum item
        <router-link style="position: relative; margin-left: 20px" :to="cartProviderActivity"><button class="button">VISITE</button></router-link>
      </span>
    </div>
    <div class="cart-container" v-else>
      <!-- <span class="cart-title"><i class="fas fa-star"></i><label>Favoritos</label></span> -->
      <div class="cart-preview-wrapper" v-if="selectedItem">
        <div class="cart-preview-container">
          <a :href="selectedItem.link" target="_blank" v-if="selectedItem.category != 'images'">Abrir</a>
          <h2 v-html="selectedItem.item"></h2>
          <router-link style="all: unset; cursor: pointer" :to="{ name: cartProviderActivity.name, params: { stream: cartProviderActivity.params.stream, standFromLink: selectedItem.provider } }">
            <h3>{{ parsedProviderTitle(selectedItem.provider) }}</h3>
          </router-link>
          <span v-html="selectedItem.description"></span>
          <section class="preview-iframes-container" v-if="selectedItem.category == 'url' || selectedItem.category == 'video'">
            <iframe class="video-iframe" :src="selectedItem.link" frameborder="0" v-if="selectedItem.category == 'video'"></iframe>
            <iframe class="pdf-iframe" :src="selectedItem.link" frameborder="0" v-else></iframe>
          </section>
          <section style="overflow-y: auto; max-height: 500px; display: flex; flex-wrap: wrap; gap: 6px" v-if="selectedItem.category == 'images'">
            <div v-for="image in JSON.parse(selectedItem.properties.images)" :key="image.id">
              <img style="" :src="image.src" />
            </div>
          </section>
        </div>
      </div>
      <div v-bind="dragFieldOptions" class="cart-list-wrapper">
        <div class="cart-list-item-container" v-for="provider in providers" :key="provider.id" v-show="cartItems.filter((i) => i.provider == provider.provider).length != 0">
          <span class="cart-list-header-container" @click="provider.collapsed = !provider.collapsed">
            <router-link style="all: unset" :to="{ name: cartProviderActivity.name, params: { stream: cartProviderActivity.params.stream, standFromLink: selectedItem.provider } }">
              <label style="cursor: pointer" v-if="cartItems.filter((i) => i.provider == provider.provider).length != 0">{{ parsedProviderTitle(provider.title) }}</label>
            </router-link>
            <i class="far fa-caret-square-down" style="margin-left: auto" v-if="provider.collapsed"></i>
            <i class="fas fa-caret-square-up" style="margin-left: auto" v-if="!provider.collapsed"></i>
          </span>
          <draggable
            handle=".handle"
            class="cart-draggable-wrapper"
            :style="{ height: provider.collapsed ? '141px' : 'unset' }"
            :group="provider.provider"
            v-model="cartItems"
            v-bind="dragFieldOptions"
            @start="isReordering = true"
            @end="handleItemOrdering">
            <div style="display: flex; width: 100%" v-for="item in cartItems" :key="item.cart_id" @click.prevent="itemClicked(item)">
              <div class="cart-item-container" :class="{ selected: item.cart_id == selectedItem.cart_id }" v-if="item.provider == provider.provider">
                <div class="cart-item-thumb">
                  <img :src="item.thumbnail ? item.thumbnail : item.image" :alt="item.item" />
                </div>
                <div class="cart-item-txts">
                  <h2 v-html="item.item"></h2>
                  <h3>{{ parsedProviderTitle(item.provider) }}</h3>
                  <span v-html="item.description"></span>
                </div>
                <div class="cart-item-btns" @click.prevent="apiDeleteCart(item)">
                  <i class="far fa-trash-alt" v-if="!item.isDeleting"></i>
                  <SpinnerButton v-else />
                </div>
                <i class="fa fa-align-justify handle"></i>
              </div>
            </div>
          </draggable>
        </div>
      </div>
    </div>
    <Footer style="position: fixed" />
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import SpinnerButton from '@/components/ui/SpinnerButton.vue';
import api from '@/services/api';
import * as dayjs from 'dayjs';
import draggable from 'vuedraggable';

export default {
  name: 'Cart',
  components: { Header, Footer, draggable, SpinnerButton },

  data() {
    return {
      dayjs: null,
      cartItems: [],
      profileConfig: null,
      selectedItem: null,
      isReordering: false,
      providers: null,
      cartProviderActivity: { name: 'Network', params: { stream: null } },
    };
  },

  beforeMount() {
    this.dayjs = dayjs;
    this.profileConfig = this.$store.state.template.profileConfig;
    this.cartProviderActivity = this.$store.state.template.userProfile.cartProvider;
    this.apiGetCart();
  },
  computed: {
    dragFieldOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
  },
  methods: {
    apiGetCart() {
      api
        .get(`event/${this.$store.state.eventId}/cart`)
        .then((response) => {
          // console.log('get cart response: ', { response });
          this.cartItems = response.data.map((item) => {
            item.isDeleting = false;
            item.isReordering = false;
            item.properties = JSON.parse(item.properties);
            return item;
          });
          this.providers = [...new Set(this.cartItems.map((item) => item.provider))];
          this.providers = this.providers.map((item, n) => ({ id: item, title: item, provider: item, collapsed: false, order: n }));
          this.selectedItem = this.cartItems[0];
        })
        .catch((err) => console.log(err));
    },
    apiPutCart(item) {
      let payload = {
        item: item.item,
        order: item.order,
        properties: JSON.stringify(item.properties),
      };
      api
        .put(`event/${this.$store.state.eventId}/cart/${item.cart_id}`, payload)
        .then((response) => {
          // console.log('put cart response: ', item.order, { response });
        })
        .catch((err) => console.error(err));
    },
    apiDeleteCart(item) {
      item.isDeleting = true;

      if (confirm('Remover favorito?')) {
        api
          .delete(`event/${this.$store.state.eventId}/cart/${item.cart_id}`)
          .then((response) => {
            item.isDeleting = false;
            this.cartItems = this.cartItems.filter((i) => i.cart_id != item.cart_id);
          })
          .catch((err) => console.log(err));
      } else item.isDeleting = false;
    },
    itemClicked(item) {
      this.selectedItem = item;
    },
    handleItemOrdering() {
      this.isReordering = true;
      let cartItems = JSON.parse(JSON.stringify(this.cartItems));

      cartItems.map((item, n) => {
        item.order = n;
        this.cartItems.map((cart) => {
          if (item.cart_id == cart.cart_id) {
            cart.order = n;
            // console.log('SELECTED TRAIL: ', { item });
            this.apiPutCart(cart);
          }
          return cart;
        });
      });
      this.$nextTick(() => {
        this.isReordering = false;
      });
    },
    handleGroupOrdering() {
      this.isReordering = true;
      this.providers.map((item, n) => (item.order = n));
      this.$nextTick(() => {
        this.isReordering = false;
      });
    },
    parsedProviderTitle(title) {
      return title;
      if (title.split(/-(.+)/)[1]) return title.split(/-(.+)/)[1].trim();
      else return title;
    },
  },
};
</script>

<style lang="scss">
.cart-section {
  position: relative;
  color: var(--userProfile-textColor);
  background-color: var(--main-color);
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: repeat-y;
  width: 100%;
  height: 100%;
  min-height: calc(100dvh);
  padding-top: 106px;

  display: flex;
  flex-direction: column;

  @include media('<=phone') {
    padding: 62px 0;
  }
}
.cart-title {
  position: relative;
  width: max-content;
  font-size: 3rem;
  text-align: left;
  margin-left: 11%;
  padding: 6px 16px 6px 6px;
  border-radius: var(--userProfile-borderRadius);
  filter: brightness(0.8);
  background: #111;
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background: none;
    -webkit-backdrop-filter: brightness(100%) blur(40px);
    backdrop-filter: brightness(100%) blur(40px);
  }
  @include media('<=tablet') {
    margin-left: 30px;
  }
  @media (max-width: 860px) {
    margin-left: 20px;
  }
  @include media('<=phone') {
    margin-left: 2.3%;
  }
  display: flex;
  align-items: center;
  i {
    color: var(--userProfile-textColor);
    font-size: 2.3rem;
    margin-right: 10px;
    @include media('<=phone') {
      font-size: 2rem;
    }
  }
  label {
    font-size: 3rem;
    @include media('<=phone') {
      font-size: 2.3rem;
    }
  }
}
.cart-container {
  position: relative;
  padding: 0 10% 120px 10%;

  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  align-items: flex-start;
  justify-content: flex-start;

  @include media('<=tablet') {
    flex-direction: column;
    padding: 1% 2% 120px;
  }
  @include media('<=phone') {
    padding: 1% 4px;
  }
}
.cart-preview-wrapper {
  position: relative;
  width: 40%;
  min-height: 260px;
  flex-grow: 1;
  border-radius: var(--userProfile-borderRadius);
  border-top-left-radius: unset;
  border-bottom-left-radius: unset;
  padding: 2%;

  display: flex;
  flex-wrap: wrap;

  background: #111;
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background: none;
    -webkit-backdrop-filter: brightness(100%) blur(40px);
    backdrop-filter: brightness(100%) blur(40px);
  }
  @include media('<=tablet') {
    width: 100%;
    padding: 20px;
    border-top-left-radius: var(--userProfile-borderRadius);
    border-bottom-right-radius: unset;
  }
}
.cart-preview-container {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;

  a {
    position: absolute;
    right: 20px;
    color: var(--userProfile-textColor);
    border: none;
    background: none;
    z-index: 1;
  }
  h2 {
    position: relative;
    margin-bottom: 6px;
    font-size: 2rem;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: capitalize;
  }
  h3 {
    position: relative;
    font-size: 1.3rem;
    margin-bottom: 10px;
    filter: brightness(0.7);
  }
  span {
    position: relative;
    margin-bottom: 12px;

    overflow: hidden;
    text-overflow: ellipsis;
  }

  img {
    position: relative;
    max-width: 100%;
    max-height: 400px;
    object-fit: contain;
    @include media('<=phone') {
      height: 200px;
    }
  }
  button {
    cursor: pointer;
    position: relative;
    width: 100%;
    max-width: 500px;
    margin-top: 20px;
    padding: 10px;
    color: var(--userProfile-textColor);
    background: var(--userProfile-buttonBgColor);
    border-radius: calc(var(--userProfile-borderRadius) / 2);

    @include media('<=phone') {
      margin: 16px 0 0;
    }
  }
  .preview-iframes-container {
    position: relative;
    width: 100%;
    .pdf-iframe {
      position: relative;
      width: 100%;
      flex-grow: 1;
      height: 47vh;
      margin-top: 10px;
    }
    .video-iframe {
      position: relative;
      width: 100%;
      height: calc(20vw);
      margin-top: 10px;
      padding: 0;
      @include media('<=tablet') {
        height: 400px;
      }
      @include media('<=phone') {
        height: 200px;
      }
    }
  }
}
.cart-list-wrapper {
  position: relative;
  width: 60%;
  flex-grow: 1;
  height: calc(92vh - 240px);
  padding: 16px 2% 2%;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: var(--userProfile-borderRadius);
  border-top-right-radius: unset;
  user-select: none;
  background: #111;
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background: none;
    -webkit-backdrop-filter: brightness(100%) blur(40px);
    backdrop-filter: brightness(100%) blur(40px);
  }
  @include media('<=tablet') {
    width: 100%;
    padding: 14px;
    border-top-right-radius: var(--userProfile-borderRadius);
  }
  @include media('<=phone') {
    padding: 0 14px;
  }

  button {
    position: relative;
    width: 100%;
    margin-bottom: 8px;
    color: var(--userProfile-textColor);
    background: none;
    font-size: 1.6rem;
    text-align: left;
    border: none;
    cursor: pointer;
  }
  &::-webkit-scrollbar {
    background-color: transparent;
    width: 0px;
  }
}
.cart-list-item-container {
  position: relative;
  margin-bottom: 30px;
}
.cart-list-header-container {
  cursor: pointer;
  position: relative;
  width: 100%;
  font-size: 1.6rem;
  margin: 0 0 6px;
  display: flex;

  i {
    filter: brightness(0.7);
  }
}
.cart-draggable-wrapper {
  position: relative;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  &::-webkit-scrollbar {
    background-color: transparent;
    width: 0px;
  }
  // &::-webkit-scrollbar-track {
  // }
  // &::-webkit-scrollbar-thumb {
  // }
}
.cart-item-container.selected {
  background: var(--userProfile-buttonBgColor);
  color: var(--userProfile-buttonTextColor);
  // filter: hue-rotate(180deg);

  .handle {
    filter: brightness(1);
  }
  .cart-item-btns i {
    filter: brightness(1);
  }
}
.cart-item-container {
  cursor: pointer;
  position: relative;
  width: 100%;
  min-height: 80px;
  padding: 14px;
  margin: 0 0 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background: var(--userProfile-middleBgColor);
  border-radius: calc(var(--userProfile-borderRadius) / 2);
  &:active {
    transform: scale(0.99);
  }
  img {
    position: relative;
    width: 100px;
    max-height: 100px;
    margin: 0 16px 0 0;
    object-fit: contain;
    object-position: top;
    // border-radius: 50%;
  }
  .cart-item-thumb {
    position: relative;
  }
  .cart-item-txts {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    @include media('<=phone') {
      max-width: 42vw;
    }
    h2 {
      position: relative;
      width: 100%;
      text-transform: capitalize;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    h3 {
      position: relative;
      font-size: 1.3rem;
      margin-bottom: 4px;
      filter: brightness(0.7);
    }
    span {
      position: relative;
      width: 100%;
    }
  }

  .cart-item-btns {
    position: relative;
    height: 100%;
    margin-left: auto;
    display: flex;
    align-items: center;
    transition: all 200ms ease-in-out;
    i {
      filter: brightness(0.6);

      &:hover {
        transform: scale(1.3);
        filter: brightness(1);
      }
    }
  }
  .handle {
    align-self: center;
    position: relative;
    font-size: 24px;
    margin: 0 8px 16px 14px;
    transition: all 100ms ease-in-out;
    transform: scaleY(1.1);
    filter: brightness(0.6);
    &:hover {
      transform: scale(1.3);
      filter: brightness(1);
    }
  }
}
</style>
